import { Box, Button, Card, Typography, CircularProgress } from "@mui/material";
import DomainIcon from "@mui/icons-material/Domain";
import EditIcon from "@mui/icons-material/Edit";
import { colors, alphaVar } from "../../../../ui/colors";
import { ClientInfo } from "../types";

interface ClientInfoCardProps {
  client: ClientInfo;
  isLoading?: boolean;
  onChangeClient?: () => void;
}

export const ClientInfoCard = ({ client, isLoading = false, onChangeClient }: ClientInfoCardProps) => {
  return (
    <Card
      sx={{
        borderRadius: 2,
        border: "none",
        p: { xs: 2, sm: 2.5, md: 3 },
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: { xs: 2, sm: 2.5, md: 3 },
        boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
        bgcolor: "background.paper",
      }}
    >
      <Box
        sx={{
          width: { xs: 64, sm: 80, md: 96 },
          height: { xs: 64, sm: 80, md: 96 },
          bgcolor: alphaVar(colors.gray[100], 0.5),
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <DomainIcon sx={{ fontSize: { xs: 32, sm: 40, md: 48 }, color: colors.gray[300] }} />
      </Box>
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: { xs: 0.75, sm: 0.875, md: 1 },
              flexWrap: "wrap",
              gap: { xs: 1, sm: 0.75, md: 0 },
            }}
          >
            <Typography variant="h6" fontWeight="bold" color="text.primary" sx={{ fontSize: { xs: "1rem", sm: "1.125rem", md: "1.25rem" } }}>
              {`${client.firstName} ${client.lastName}`}
              {client.alias && (
                <Box component="span" sx={{ fontWeight: "normal", color: "text.secondary", ml: 1, fontSize: "0.85em" }}>
                  ({client.alias})
                </Box>
              )}
            </Typography>
            {onChangeClient && (
              <Button
                size="small"
                color="primary"
                startIcon={isLoading ? <CircularProgress size={14} /> : <EditIcon sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }} />}
                onClick={onChangeClient}
                disabled={isLoading}
                sx={{
                  fontWeight: "bold",
                  textTransform: "none",
                  fontSize: { xs: "0.75rem", sm: "0.8125rem", md: "0.875rem" },
                  py: { xs: 0.5, sm: 0.625, md: 0.75 },
                  px: { xs: 1, sm: 1.25, md: 1.5 },
                }}
              >
                Change Client
              </Button>
            )}
          </Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              lineHeight: 1.6,
              fontSize: { xs: "0.75rem", sm: "0.8125rem", md: "0.875rem" },
            }}
          >
            {client.email}
            <br />
            {client.phone}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};
